import { render, staticRenderFns } from "./GallerySlideCarousels.vue?vue&type=template&id=7f22ec95&scoped=true&"
import script from "./GallerySlideCarousels.vue?vue&type=script&lang=js&"
export * from "./GallerySlideCarousels.vue?vue&type=script&lang=js&"
import style0 from "./GallerySlideCarousels.vue?vue&type=style&index=0&id=7f22ec95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f22ec95",
  null
  
)

export default component.exports